import { render, staticRenderFns } from "./FormGroupSelectItem.vue?vue&type=template&id=0027bf81&scoped=true"
import script from "./FormGroupSelectItem.vue?vue&type=script&lang=js"
export * from "./FormGroupSelectItem.vue?vue&type=script&lang=js"
import style0 from "./FormGroupSelectItem.vue?vue&type=style&index=0&id=0027bf81&scoped=true&lang=css"
import style1 from "./FormGroupSelectItem.vue?vue&type=style&index=1&id=0027bf81&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0027bf81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0027bf81')) {
      api.createRecord('0027bf81', component.options)
    } else {
      api.reload('0027bf81', component.options)
    }
    module.hot.accept("./FormGroupSelectItem.vue?vue&type=template&id=0027bf81&scoped=true", function () {
      api.rerender('0027bf81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/tableComp/formItems/FormGroupSelectItem.vue"
export default component.exports